import {useAuthContext} from 'geestack-toolbox';
import {UserDto} from '../scaffold';

export default function useAuth() {
  return useAuthContext<UserDto>();
}
